import React from "react";

function Portfolio() {
  return (
    <>
      <section class="portfolio">
        <h1 class="heading">
          {" "}
          <span>my</span> work{" "}
        </h1>

        <div class="box-container">
          <div class="box">
            <img src="/Images/img-1.png" alt="" />
            <div class="content">
              <h3>project 01</h3>
              <p>E-Christmas MERN Stack, Redux for State Management</p>
              <a
                target="_blank"
                href="https://regal-croissant-69885f.netlify.app/"
              >
                OPEN
              </a>
            </div>
          </div>

          <div class="box">
            <img src="/Images/img-2.png" alt="" />
            <div class="content">
              <h3>project 02</h3>
              <p>
                Blog Website- Users can write blogs after login, Redux for State
                Management
              </p>
              <a
                target="_blank"
                href="https://loquacious-pastelito-f799a2.netlify.app/"
              >
                OPEN
              </a>
            </div>
          </div>

          <div class="box">
            <img src="/Images/img-3.png" alt="" />
            <div class="content">
              <h3>project 03</h3>
              <p>Student Management</p>
              <a
                target="_blank"
                href="https://brilliant-macaron-504caa.netlify.app/"
              >
                OPEN
              </a>
            </div>
          </div>

          <div class="box">
            <img src="/Images/img-4.png" alt="" />
            <div class="content">
              <h3>project 04</h3>
              <p>PKIA Redesign</p>
              <a
                target="_blank"
                href="https://visionary-creponne-073827.netlify.app"
              >
                OPEN
              </a>
            </div>
          </div>

          <div class="box">
            <img src="/Images/img-5.png" alt="" />
            <div class="content">
              <h3>project 05</h3>
              <p>CDAC Ledger</p>
              <a
                target="_blank"
                href="https://regal-bublanina-018bba.netlify.app/"
              >
                OPEN
              </a>
            </div>
          </div>
          <div class="box">
            <img src="/Images/img-6.png" alt="" />
            <div class="content">
              <h3>project 06</h3>
              <p>Disney+</p>
              <a target="_blank" href="https://disney-clone-d5bfb.web.app ">
                OPEN
              </a>
            </div>
          </div>
          <div class="box">
            <img src="/Images/img-7.png" alt="" />
            <div class="content">
              <h3>project 07</h3>
              <p>Netflix</p>
              <a target="_blank" href="https://famous-dusk-0866f1.netlify.app/">
                OPEN
              </a>
            </div>
          </div>
          <div class="box">
            <img src="/Images/img-8.png" alt="" />
            <div class="content">
              <h3>project 08</h3>
              <p>News</p>
              <a
                target="_blank"
                href="https://incomparable-cat-7126aa.netlify.app/"
              >
                OPEN
              </a>
            </div>
          </div>
          <div class="box">
            <img src="/Images/img-9.png" alt="" />
            <div class="content">
              <h3>project 09</h3>
              <p>CDAC Wizards</p>
              <a
                target="_blank"
                href="https://celebrated-sherbet-3e4a71.netlify.app/"
              >
                OPEN
              </a>
            </div>
          </div>
          <div class="box">
            <img src="/Images/img-10.png" alt="" />
            <div class="content">
              <h3>project 10</h3>
              <p> Infinity Hub</p>
              <a href="#"></a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Portfolio;
